import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=06b1fb2e&"
import script from "./LoginView.vue?vue&type=script&lang=js&"
export * from "./LoginView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b1fb2e')) {
      api.createRecord('06b1fb2e', component.options)
    } else {
      api.reload('06b1fb2e', component.options)
    }
    module.hot.accept("./LoginView.vue?vue&type=template&id=06b1fb2e&", function () {
      api.rerender('06b1fb2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/login/LoginView.vue"
export default component.exports